import React from "react";
import PteReadingExplanationButton from "./PteReadingExplanationButton";
import { getPteReadingExplanationTargets } from "./pteReadingExplanationUtils";

const PteReadingQuestionExplanation = ({
  isSubmitted,
  testData,
  explanationContext = null,
}) => {
  if (!isSubmitted || !testData?.UserResponse) return null;

  const targets = getPteReadingExplanationTargets({
    subCategory: testData.UserResponse.SubCategory,
    correctAnswers: testData.UserResponse.correctAnswers,
    submissionResult: testData.UserResponse.submissionResult,
  });
  const questionTarget = targets.find((target) => target.type === "question");
  if (!questionTarget) return null;

  return (
    <PteReadingExplanationButton
      explanationContext={explanationContext}
      testData={testData}
      target={questionTarget}
      variant="action"
    />
  );
};

export default PteReadingQuestionExplanation;
